import React, { useContext } from 'react';
import { bool } from 'prop-types';
import { Carousel } from '@one-thd/sui-carousel';
import {
  Card,
  CardContent,
  Typography
} from '@one-thd/sui-atomic-components';
import { StorePod, StorePodServices } from '@thd-olt-component-react/store-pod';
import { StoreHeroContext } from '../../StoreHero.context';
import { FeaturesList } from './features-list/FeaturesList';

const StoreHeroFeatures = ({ showServices }) => {
  const { loading, store } = useContext(StoreHeroContext);

  const slides = [
    <FeaturesList key="FeaturesListSlide" />,
    <StorePod key="StorePodSlide" loading={loading} store={store}>
      <StorePodServices disablePlaceholder showIcon />
    </StorePod>
  ];

  if (showServices) {
    return (
      <div className="sui-flex sui-items-center">
        <Card grow data-component="StoreHeroFeatures" PaperProps={{ className: 'sui-w-full' }}>
          <Typography variant="h2">Store Features</Typography>
          <CardContent disablePadding>
            <Carousel
              slidesPerView={1}
              disableMargin
              spaceBetween={12}
              type="hero"
            >
              {slides}
            </Carousel>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <Card grow data-component="StoreHeroFeatures">
      <Typography variant="h2">Store Features</Typography>
      <CardContent disablePadding>
        <FeaturesList />
      </CardContent>
    </Card>
  );
};

StoreHeroFeatures.propTypes = {
  showServices: bool
};

StoreHeroFeatures.defaultProps = {
  showServices: false
};

StoreHeroFeatures.displayName = 'StoreHeroFeatures';

export { StoreHeroFeatures };
